import { render, staticRenderFns } from "./ContractExpensesTab.vue?vue&type=template&id=7b40538e&"
import script from "./ContractExpensesTab.vue?vue&type=script&lang=js&"
export * from "./ContractExpensesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports